import { Branding, BrandingDisabledIf, DisabledPrompt, useModel, useRoute } from "bcms-react";
import Util from "classes/Util";
import { SVGAsset } from 'res';
import { MobileNavItem, MobileNavMenuItem, MobileNavDropdownMenuItem, MobileNavSubDropdownMenuItem } from "../..";

/**
 * @function BID1224MobileNavItems
 * @extends React.Component
 * @exported true
 * @description The main component for navigation for BID 1224 in mobile.
 * @example
   <BID1224MobileNavView links={{
    profile: profileItem,
    settings: settingsItem
   }}/>
 */
export default function BID1224MobileNavItems(props) {
    const { demos, branding } = useModel();
    const navigate = useRoute();
    const paymentsLabel = "Bill Pay";
    const items = props.items ?? {};

    const openAccount = evt => {
        if(Util.inMabi) {
            window.parent.postMessage({ message:"force-global-route", detail: {
                route: `/content/orig`
            }   
            }, "*");
        } else {
            let origVersion = branding.options.orig_version_abi22;
            if(origVersion !== "ORIG19") origVersion = "ORIG20";
            window.open(demos[origVersion], "_blank");
        }
    }

    const onCardsClick = evt => {
    if(Util.inMabi) {
        Util.openABI22StandaloneOverlayInMABI23();
        } else {
        navigate("/ch21");
        }
    }

    const newAccountsItem = <MobileNavDropdownMenuItem className="accounts-mobile-link" itemIcon={<SVGAsset id="WalletIcon" />} label="Accounts" dataPoint="Nav_Accounts">
                            <MobileNavMenuItem className="account-summary-mobile-link" to="/accountSummary" label="Account Summary" dataPoint="Nav_Account_Summary" />
                            <MobileNavMenuItem className="stop-payments-mobile-link" to="/stopPayment" label="Stop Payments" dataPoint="Nav_Stop_Payments" />
                        </MobileNavDropdownMenuItem>;

    const paymentsItem = <BrandingDisabledIf id="rxpmw_courseid_abi22" exp={ value => value !== null }>
                            <MobileNavItem className="rxpmw-mobile-link" itemIcon={ <SVGAsset id="DollarSignOutlineIcon" /> } label={ paymentsLabel } to="/rxpmw" dataPoint="Nav_Bill_Pay" />
                        </BrandingDisabledIf>;

    const transfersItem = <MobileNavDropdownMenuItem className="transfer-mobile-link"  itemIcon={<SVGAsset id="TransfersIcon" />}label="Transfers" dataPoint="Nav_Transfers">
                            <MobileNavMenuItem className="make-a-transfer-mobile-link" to="/transfers" label="Make a Transfer" dataPoint="Nav_Make_Transfer" />
                            <BrandingDisabledIf id="tn19_courseID_abi22" exp={ value => value !== null }>
                                <MobileNavMenuItem className="external-transfers-mobile-link" label="External Transfers" to="/externalTransfers" dataPoint="Nav_External_Transfers" />
                            </BrandingDisabledIf>  
                            <MobileNavMenuItem className="transfer-activity-mobile-link" to="/transferActivity/scheduledTransfers" label="Transfer Activity" dataPoint="Nav_Transfer_Activity" />
                        </MobileNavDropdownMenuItem>;

    const cardsItem = <MobileNavDropdownMenuItem className="cards-link" itemIcon={ <SVGAsset id="CardIcon" /> } label="Cards" dataPoint="Nav_Cards">
                        <DisabledPrompt>
                            <MobileNavMenuItem className="credit-cards-link" label="Credit Cards" dataPoint="Nav_Credit_Cards" />
                        </DisabledPrompt>
                        <BrandingDisabledIf id="ch21_courseid_abi22" exp={ value => value !== undefined && value !== null }>
                            { Util.inMabi && 
                                <MobileNavMenuItem className="ch21-mobile-link" label="Debit Card Management" onClick={ onCardsClick } dataPoint="Nav_Debit_Card_Management" />
                            }
                            { !Util.inMabi && 
                                <MobileNavMenuItem className="ch21-mobile-link" label="Debit Card Management" to="/ch21" dataPoint="Nav_Debit_Card_Management" />
                            }
                        </BrandingDisabledIf>
                    </MobileNavDropdownMenuItem>;
                    
    const depositsItem = <MobileNavDropdownMenuItem className="deposits-mobile-link"  itemIcon={<SVGAsset id="CameraIcon" />} label="Deposits" dataPoint="Nav_Deposits">
                        <MobileNavMenuItem className="deposit-a-check-link" to="/depositACheckWorkflow" label="Deposit a Check" dataPoint="Nav_Deposit_A_Check" />
                        <MobileNavMenuItem className="deposit-history-link"  to="/depositHistory" label="Deposit History" dataPoint="Nav_Deposit_History" />
                        </MobileNavDropdownMenuItem>;

    const alertsItem = <BrandingDisabledIf id="notifi_version_abi22"  exp={(val) => val !== "Disabled" }>   
                        <MobileNavItem className="alerts-mobile-link" label={ "Manage Alerts" }  to="/notifications" dataPoint="Nav_Manage_Alerts" />
                    </BrandingDisabledIf>;

    const openAnAccountItem = <DisabledPrompt>
                                <MobileNavItem className="open-an-account-mobile-link" label={ "Open an Account" }   dataPoint="Nav_Open_Account" onClick={ openAccount } />
                            </DisabledPrompt>;

    const profileItem =  <MobileNavDropdownMenuItem className="profile-mobile-link" itemIcon={<SVGAsset id="CircleProfileIcon" />} label="Profile" dataPoint="Utility_Profile">
                            <MobileNavMenuItem className="email-mobile-link" to="/email" label="Email Address" dataPoint="Utility_Email" />
                            <MobileNavMenuItem className="phone-mobile-link" to="/phoneNumber" label="Phone Number" dataPoint="Utility_Phone" />
                            <DisabledPrompt>
                                <MobileNavMenuItem className="address-mobile-link" to="/address" label="Address" dataPoint="Utility_Address" />
                            </DisabledPrompt>
                            <MobileNavMenuItem className="password-mobile-link" to="/password" label="Password" dataPoint="Utility_Password" />
                            <MobileNavMenuItem className="user-id-mobile-link" label="User ID" to="/userId" dataPoint="Utility_User_ID" />   
                            <DisabledPrompt>
                                <MobileNavMenuItem className="unauthorized-devices-link" label="Unauthorized Devices" dataPoint="Utility_Unauthorized_Devices" />
                            </DisabledPrompt>
                        </MobileNavDropdownMenuItem>;

    const settingsItem = <MobileNavDropdownMenuItem className="settings-mobile-link"  itemIcon={<SVGAsset id="GearIcon" />} label="Settings" dataPoint="Utility_Settings">
                        <MobileNavMenuItem className="authorized-device-enrollment-mobile-link" to="/authorizedDeviceEnrollmentWorkflow" label="Authorized Device Enrollment" dataPoint="Utility_Authorized_Device_Enrollment" /> 
                        <MobileNavMenuItem className="authorized-devices-alerts-mobile-link" to="/authorizedDevicesWorkflow" label="Authorized Devices" dataPoint="Utility_Authorized_Devices" />
                        <MobileNavMenuItem className="fast-balances-mobile-link" to="/settingsFastBalancesWorkflow" label="Fast Balances" dataPoint="Utility_Instance_Balances" />
                        <MobileNavMenuItem className="user-activity-mobile-link" to="/userActivityWorkflow" label="User Activity" dataPoint="Utility_User_Activity" />
                        <MobileNavMenuItem className="accepted-disclosures-mobile-link" to="/acceptedDisclosuresWorkflow" label="Accepted Disclosures" dataPoint="Utility_Accepted_Disclosures" />
                        <DisabledPrompt>
                            <MobileNavMenuItem className="delete-an-account-mobile-link" to="/deleteanaccount" label="Delete an Account" dataPoint="Utility_Delete_Account" />
                        </DisabledPrompt>
                    </MobileNavDropdownMenuItem>;

    const additionalServicesItem = <MobileNavDropdownMenuItem className="additional-services-mobile-link"  itemIcon={<SVGAsset id="HeadsetIcon" />} label="Additional Services" dataPoint="Nav_Additional_Services">
                                <DisabledPrompt>
                                    <MobileNavMenuItem className="lending-solutions-link" label="Lending Solutions" dataPoint="Nav_Lending_Solutions" />
                                </DisabledPrompt>
                                <DisabledPrompt>
                                    <MobileNavMenuItem className="unauthorized-debit-card-dispute-link" label="Unauthorized Debit Card Dispute" dataPoint="Nav_Unauthorized_Debit_Card_Dispute" />
                                </DisabledPrompt>
                                <DisabledPrompt>
                                    <MobileNavMenuItem className="monthly-interest-transfer-form-link" label="Monthly Interest Transfer Form" dataPoint="Nav_Monthly_Interest_Transfer_Form" />
                                </DisabledPrompt>
                                <DisabledPrompt>
                                    <MobileNavMenuItem className="today-at-manasquan-link" label="Today at Manasquan" dataPoint="Nav_Today_At_Manasquan" />
                                </DisabledPrompt>
                                <DisabledPrompt>
                                    <MobileNavMenuItem className="schedule-an-appointment-link" label="Schedule an Appointment" dataPoint="Nav_Schedule_An_Appointment" />
                                </DisabledPrompt>
                                <DisabledPrompt>
                                    <MobileNavMenuItem className="save-your-change-link" label="Save Your Change" dataPoint="Nav_Save_Your_Change" />
                                </DisabledPrompt>
                                <DisabledPrompt>
                                    <MobileNavMenuItem className="branch-locations-link" label="Branch Locations" dataPoint="Nav_Branch_Locations" />
                                </DisabledPrompt>
                                <DisabledPrompt>
                                    <MobileNavMenuItem className="contact-us-link" label="Contact Us" dataPoint="Nav_Contact_Us" />
                                </DisabledPrompt>
                            </MobileNavDropdownMenuItem>;

    const messagesItem = <MobileNavItem className="messages-mobile-link" to="/messages" label="Messages" itemIcon={<SVGAsset id="EnvelopeIcon" />} dataPoint="Nav_Messages">
                        <div className="set-width alert-bubble flex-container all-center">
                            <span>3</span>
                        </div>
                    </MobileNavItem>;

    const pfmItem = <BrandingDisabledIf id="pfm21_courseID_abi22" exp={ value => value !== null } >
                        <MobileNavItem className="pfm21-mobile-link" itemIcon={ <SVGAsset id="PiggyBankDollarSignIcon" /> } label="My Finances" to="/myFinances" dataPoint="Nav_My_Finances" />
                    </BrandingDisabledIf>;

  return (
   <Branding id="bid_abi22" value="1224" >
          { newAccountsItem }
          { transfersItem }
          { paymentsItem }
          { cardsItem }
          { alertsItem }
          { openAnAccountItem }
          { depositsItem }
          { pfmItem }
          { profileItem }
          { settingsItem } 
          { additionalServicesItem }
          { messagesItem }
     </Branding>
  );
}

